import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MuiButton from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import Input from "../components/UI/Input";
import useForm from "../hooks/useForm";
import Checkbox from "../components/UI/Checkbox";
import { USER_EMAIL } from "../utils/constants";
import { request } from "../utils/axios-utils";
import Cookies from "js-cookie";

const LeftArrow = require("../assets/icons8-left-48.png");

export type Website = {
  name?: string;
  domain?: string;
  email?: string;
  flag_alerts?: string | boolean;
};

const initialValue = {
  name: "",
  domain: "",
  email: "",
  flag_alerts: false,
};

const CreatePage = () => {
  const [domainError, setDomainError] = useState(false);
  const navigate = useNavigate();
  const { values, handleInputChange, setErrors, errors } =
    useForm(initialValue);
  const { t } = useTranslation();

  const email = Cookies.get(USER_EMAIL);

  const titlePlaceholder = t("controlPanelCreatePageInputTitlePlaceholder");
  const agreeValidation = t("controlPanelCreatePageInputAgreeValidation");
  const titleValidation = t("controlPanelCreatePageInputTitleValidation");
  const domainValidation = t("controlPanelCreatePageInputDomenValidation");

  const validate = () => {
    let temp: Website = {};
    temp.name = values.name ? "" : titleValidation;
    // temp.email = values.email ? "" : titleValidation;
    temp.domain =
      /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/.test(
        values.domain
      )
        ? ""
        : domainValidation;

    temp.flag_alerts = values.flag_alerts
      ? ""
      : "Примите условия чтобы продолжить";

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (validate()) {
      request({ url: "api/v2/project/create", method: "post", data: values })
        .then((res): any => {
          const { id } = res.data;
          navigate(`/panel/${id}/setup`);
        })
        .catch((err) => {
          setDomainError(true);
          console.error(err.request);
        });
    }
  };

  return (
    <Container>
      <div className="top_box">
        <Button onClick={() => navigate(-1)}>
          <img src={LeftArrow} alt="left" />
        </Button>
        <p>{t("controlPanelCreatePageHeader")}</p>
      </div>
      <div className="box">
        <form autoComplete="off" onSubmit={handleSubmit}>
          <FormContainer>
            <Input
              id="component-title"
              value={values.name}
              name="name"
              label={t("controlPanelCreatePageInputTitle")}
              placeholder={titlePlaceholder}
              multiline={true}
              error={errors.name}
              onChange={handleInputChange}
            />
            <Input
              id="component-domain"
              value={values.domain}
              name="domain"
              label={t("controlPanelCreatePageInputDomen")}
              placeholder="example.com"
              multiline={true}
              error={errors.domain || domainError}
              onChange={handleInputChange}
            />
            <Input
              id="component-email"
              value={email}
              name="email"
              type="email"
              required={true}
              label={t("controlPanelCreatePageInputEmail")}
              multiline={true}
              disabled={true}
              onChange={handleInputChange}
            />
            <Checkbox
              value={values.flag_alerts}
              onChange={handleInputChange}
              name="flag_alerts"
              required={true}
              errorMessage={agreeValidation}
              errors={errors.flag_alerts}
              label={t("controlPanelCreatePageInputAgree")}
            />
          </FormContainer>
          <ButtonContainer>
            <MuiButton onClick={() => navigate(-1)} variant="outlined">
              {t("controlPanelSitesFormButtonFirst")}
            </MuiButton>
            <MuiButton type="submit" variant="contained">
              {t("controlPanelSitesFormButtonSecond")}
            </MuiButton>
          </ButtonContainer>
        </form>
      </div>
    </Container>
  );
};

export default CreatePage;

const Button = styled.button`
  border: none;
  background: none;
  color: #000;
  height: 28px;
  cursor: pointer;

  img {
    height: 100%;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  & h1 {
    font-size: 24px;
    text-align: center;
  }

  .top_box {
    max-width: 36rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    align-items: center;
    padding: 1rem;
    border: none;
    outline: none;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    color: #000000;
    background: #9bc2e0;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }

    p {
      font-size: 16px;
    }
  }

  .box {
    max-width: 36rem;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 2rem 2.5rem;
    flex-direction: column;
    gap: 10px;
    border: none;
    outline: none;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    color: #121212;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
  }
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;
  font-size: 14px;
`;
